import * as React from 'react';
import * as ReactDOM from 'react-dom';

import * as typeExtentions from './infrastructure/type.extentions';
import { HashRouter } from 'react-router-dom';

import * as Redux from 'redux';
import { Provider } from 'react-redux';
import * as Models from './models/index';
import thunk from 'redux-thunk';
import { reducers } from './reducers/index';

import * as CallApi from './infrastructure/call.api';

import Shell from './shell';
import { navigateToTracks } from './infrastructure/toolbox';

typeExtentions.apply();

var host = document.getElementById('root');

const middleware = Redux.applyMiddleware(thunk);

const store = Redux.createStore<Models.StoreState>(reducers, middleware);
CallApi.applyToStore(store);

document.body.appendChild(host);

fetch('/Auth/IsAuthenticated').then(async response => {
	var isAuthenticated = await response.json();
	if (!!isAuthenticated) {
		navigateToTracks(window.location.hash);
		return;
	}
	runLoginApp();
});

const runLoginApp = () => {
	fetch('/Login/Config').then(async response => {
		const config = Models.Mapper.Login.map_LoginIndexResponse(await response.json());

		document.title = config.appName;
		document.body.className = 'styled-tracks';
		document.body.setAttribute('data-app-type', config.appType);

		await loadStyles(config.tracksStyle);

		ReactDOM.render(
			<Provider store={store}>
				<HashRouter hashType='noslash'>
					<Shell config={config} />
				</HashRouter>
			</Provider>,
			host
		);
	});
};

async function loadStyles(appStyle: string) {
	switch (appStyle?.toLowerCase()) {
		case 'tacobell':
			await import(`./styles/theme/config/tacobell/index.scss`);
			break;
		case 'coaliance':
			await import(`./styles/theme/config/coaliance/index.scss`);
			break;
		case 'kfc':
			await import(`./styles/theme/config/kfc/index.scss`);
			break;
		case 'pizza-hut':
			await import(`./styles/theme/config/pizzaHut/index.scss`);
			break;
		default:
			await import(`./styles/theme/config/habit/index.scss`);
			break;
	}
	await import('./styles/entry.scss');
}
